// All needed imports
import { Directive } from '@angular/core';

@Directive({
  selector: '[appDirective1]'
})
export class Directive1Directive {
}
